<!--
  ~ Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
  ~ This software is the proprietary information of Irian Software Development SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<div class="card">
    <div class="row">
      <p-messages [(value)]="statusMessages"></p-messages>
    </div>
    <!--<auth-user-rights #rightsForm [userData]="userData" (save)="onUserSubmit($event)"></auth-user-rights> -->
    <auth-user-inputs-and-roles-view #rightsForm (save)="onUserSubmit($event)" [emailValue]="emailValue" [roleWithRightsVOs]="roleWithRightsVOs" [showPasswords]="true" [userData]="userData"></auth-user-inputs-and-roles-view>

    <button (click)="goBack()" class="mt mr-sm flat"
            [label]="'auth.cancel' | translate" pButton data-testid="cancel-btn"></button>

    <button (click)="rightsForm.onSubmit()"
            [label]="'auth.save' | translate"
            class="mt"
            pButton data-testid="save-btn"></button>
</div>

